import apiFetch from '../apiFetch'

export default function (token, templateId, body) {
  return apiFetch({ endPoint: `template/${templateId}/field`, method: 'POST', body: body, token: token })
}
